module.exports = __webpack_public_path__ + "static/quality-b11691ba9701d6483be38030b1bbb117.png";